/**
 * Asks the browser to confirm before the tab is closed or reloaded while work that would be lost is
 * still running (e.g. an S3 upload). Browsers show their own generic message; custom text is ignored.
 *
 * Calls may overlap: the listener stays attached until the last guarded promise settles.
 */
let pending = 0

function onBeforeUnload(event: BeforeUnloadEvent) {
  event.preventDefault()
  // Legacy browsers (older Chrome/Safari) only prompt when returnValue is set.
  event.returnValue = ''
}

export async function guardLeave<T>(work: () => Promise<T>): Promise<T> {
  if (pending++ === 0) {
    window.addEventListener('beforeunload', onBeforeUnload)
  }
  try {
    return await work()
  } finally {
    if (--pending === 0) {
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }
}
